<template>
    <div>
        <!-- 产品 -->
        <div class="product">
            <HomeCard class="wrap" title="产品推荐" desc='RECOMMONDATION' img='../../assets/icon1.png' v-bind:link='{to:"/product",name:"查看更多产品"}'>
                <div v-if="products && products.length > 0" class="product-content">
                    <ScrollList :list='products'/>
                </div>
                <!-- <a-result v-else title="暂时没有数据哟~~" /> -->
                <a-empty v-else description='暂时没有数据哟~~'/>
            </HomeCard>
        </div>
        <!-- 简介 -->
        <div class="about">
            <HomeCard class="wrap" :titleStyle='true' title="公司简介" desc='briefIntroduction' img='../../assets/icon1.png'>
                <div v-if="about && about.name && about.profile" class="about-content">
                    <h2 class="c_black M_x">{{about.name}}</h2>
                    <p class="c_black M_sm">
                       {{about.profile}}
                    </p>
                    <div>
                        <a href="/#/about">了解更多 ></a>
                    </div>
                </div>
                <a-result v-else status="500" />
            </HomeCard>
        </div>

        <!-- 案例 -->
        <div class="case">
            <HomeCard class="" title="工程案例" desc='ENGINEERING CASE' img='../../assets/icon1.png' v-bind:link='{to:"/product",name:"查看更多"}'>
                <div class="case-content" v-if="cases && cases.length > 0">
                    <swiper class="swiper" :options="m_swiperOptions">
                        <swiper-slide class="swiper-item" v-for="item in cases" :key="item.id">
                            <router-link :to="'/case/details?id='+item.id" class="d_b h_1 w_1">
                                <img :src="item.projectPicUrl" alt="">
                            </router-link>
                        </swiper-slide>
                    </swiper>
                </div>
                <a-empty v-else description='暂时没有数据哟~~'/>
            </HomeCard>
        </div>

        <!-- 新闻 -->
        <div class="news">
            <HomeCard class="" title="新闻中心" desc='CENTER OF NEWS' img='../../assets/icon1.png' v-bind:link='{to:"/news",name:"查看更多"}'>
                <div v-if="news && news.length > 0" class="news-content bg_grey d_f d_f_c ai_c">
                    <newsItem 
                        v-for="item in news"
                        :key='item.id'
                        :to='"/news/details?id="+item.id'
                        :title="item.title"
                        :date = 'item.createTime'
                        :img = 'item.newsPicUrl'
                    />
                </div>
                <a-empty v-else description='暂时没有数据哟~~'/>
            </HomeCard>
            
        </div>
        <!-- 产品 -->
        <div class="introduce">
            <HomeCard class="wrap" title="产品追溯" desc=' ' img='../../assets/icon1.png'>
                <div class="introduce-content">
                    <div class="bz-bg">
                        <img src="../../assets/bz.png" alt="">
                    </div>
                    <p>
                        使用手机打开二维码扫描，对准产品右下角二维码进行扫码，可查询该产品的数据信息，参数等。
                    </p>
                </div>
            </HomeCard>
        </div>

        <homeFooter/>
    </div>
</template>

<script>
import HomeCard from '../../components/Home-card/index'
import ScrollList from '../../components/Scroll-list';
import homeFooter from '../../components/Footer/home-footer'
import newsItem from '../News/news-item'
import index from './index'
export default {
    ...index,
    components : {
        HomeCard,
        ScrollList,
        homeFooter,
        newsItem
    },
}
</script>

<style lang="scss" scoped>
    /* 产品 */
    .product{
        margin-top: 10.638vw;
        .product-content{
            height: 45.479vw;
            background-color: #f8f8f8;
        }
    }
    /* 简介 */
    .about{
        // height: 64.362vw;
        background: url(../../assets/stained.png) no-repeat 100% 100%;
        .wrap{
            padding-top: 15.202vw;
        }
        .about-content{
            height: 40.16vw;
            padding: 2.66vw;
            background-color: rgba(255, 255, 255, .5);
            h2{
                margin-bottom: 2.66vw;
            }
            p{
                line-height: 5.319vw;
                height:15.947vw;
                margin-bottom: 2.66vw;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: -o-ellipsis-lastline;
                text-overflow: ellipsis;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            div{
                text-align: right;
                line-height: 5.319vw;
                a{
                   color: #fff; 
                   font-size: 3.192vw;
                }
                
            }
        }
    }
    /* 案例 */
    .case{
        height: 54.787vw;
        margin-top: 13.298vw;
        .case-content{
            margin: 5.319vw 0;
        }
        .swiper{
            .swiper-item{
                width:63.83vw;
                height: 40.957vw;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

/* 新闻中心 */
    .news{
        padding-top: 10.319vw;
        .news-content{
            padding: 2.66vw;
        }
    }


    .bz-bg{
        width: 100%;
        height: 30.319vw;
        background:url(../../assets/bz-bg.png) no-repeat center;
        background-size: 50% 100%;
        text-align: center;
        img{
            height: 100%;
        }
    }
    .introduce{
        padding: 5.319vw 0;
        .introduce-content{
            p{
                padding:5.319vw;
                text-align: center;
            }
        }
    }
</style>
